import z from "zod";

const passwordWithConfirmSchema = z
  .object({
    password: z
      .string()
      .min(1, "Password is required")
      .min(6, "Must be at least 6 characters")
      .refine((p) => /[A-Z]/.test(p), "Must include at least 1 uppercase character")
      .refine((p) => /[a-z]/.test(p), "Must include at least 1 lowercase character")
      .refine((p) => /[0-9]/.test(p), "Must include at least 1 digit")
      .refine(
        (p) => /[`!@#$%^&*()_\-+=[\]{};':`\\|,.<>/?~ ]/.test(p),
        "Must include at least 1 special character",
      ),
    confirmPassword: z.string().trim().min(1, "Confirm password is required"),
  })
  .refine(({ password, confirmPassword }) => password === confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"],
  });

export const loginFormSchema = z.object({
  email: z.email("Email is required"),
  password: z.string().trim().min(1, "Password is required"),
});

export type LoginFormData = z.infer<typeof loginFormSchema>;

export const registerFormSchema = z
  .object({
    name: z.string().trim().min(1, "Name is required"),
    email: z.email("Email is required"),
  })
  .and(passwordWithConfirmSchema);

export type RegisterFormData = z.infer<typeof registerFormSchema>;

export const setPasswordSchema = z
  .object({
    currentPassword: z.string().trim().min(1, "Current password is required"),
  })
  .and(passwordWithConfirmSchema);

export type SetPasswordFormData = z.infer<typeof setPasswordSchema>;
